import { Model } from "@tailflow/laravel-orion/lib/model";

export class CounterPartyTags extends Model<{
  name: any;
  created_at: string;
  updated_at: string;
}> {
  public $resource(): string {
    return "counter-party-tags";
  }
}
